module.exports = "{{ commenterRole }}\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/comments/commenter-role/commenter-role.component.html
// module id = ../../../../../src/app/comments/commenter-role/commenter-role.component.html
// module chunks = main